import moment from 'moment-timezone';

export const formatDateString = 'MM/DD/YYYY';
export const formatTimeString12Hour = true;

export const formatTime = inTime => {
    if (inTime === null || inTime === undefined) return '0:00';
    let timeFormat = '0:00';

    if (inTime.split) {
        if (inTime.split(':').length === 3) {
            if (parseInt(inTime.split(':')[0]) > 0) {
                timeFormat = `${parseInt(inTime.split(':')[0])}:${inTime.split(':')[1]}:${inTime.split(':')[2]}`;
            } else {
                timeFormat = `${parseInt(inTime.split(':')[1])}:${inTime.split(':')[2]}`;
            }
        } else if (inTime.split(':').length === 2) {
            timeFormat = `${parseInt(inTime.split(':')[0])}:${inTime.split(':')[1]}`;
        } else {
            timeFormat = inTime;
        }
    } else {
        const sec_num = parseInt(inTime, 10);
        const hours = Math.floor(sec_num / 3600);
        let minutes: any = Math.floor((sec_num - hours * 3600) / 60);
        let seconds: any = sec_num - hours * 3600 - minutes * 60;

        if (minutes < 10 && hours > 0) {
            minutes = `0${minutes}`;
        }
        if (seconds < 10) {
            seconds = `0${seconds}`;
        }
        if (hours > 0) {
            timeFormat = `${hours}:${minutes}:${seconds}`;
        } else {
            timeFormat = `${minutes}:${seconds}`;
        }
    }

    return timeFormat;
};

export const formatTimeHMMSSADST = intime => {
    if (formatTimeString12Hour) {
        return _DSTAdjusted(intime).format('h:mm:ss A');
    }
    return _DSTAdjusted(intime).format('H:mm:ss');
};

export const _DSTAdjusted = inDate => {
    if (String(inDate) !== '0001-01-01T00:00:00') {
        if (String(inDate).indexOf('M') < 0) {
            // check if string is already been parsed once and contains AM or PM
            if (String(inDate).indexOf('Z') < 0) inDate += 'Z';
            const today = new Date();
            if (!moment(inDate).isDST() && moment(today).isDST()) {
                return moment(inDate).hours(moment(inDate).hours() + 1);
            }
            return moment(inDate);
        }
        return moment(inDate);
    }
    return moment(inDate);
};

export const convertMOSDateTime = value => {
    let convertedFormat = '';
    if (value !== '1800-01-01T00:00:00') {
        formatDateTimeDST(value, true);
        if (convertedFormat === 'Invalid date') {
            convertedFormat = value;
        }
    }
    return convertedFormat;
};

export const formatDateTimeDST = (inDate, seconds) => {
    if (seconds === true) {
        if (formatTimeString12Hour) {
            return _DSTAdjusted(inDate).format(`${formatDateString}, hh:mm:ss A`);
        }
        return _DSTAdjusted(inDate).format(`${formatDateString}, HH:mm:ss`);
    }

    if (formatTimeString12Hour) {
        return _DSTAdjusted(inDate).format(`${formatDateString}, hh:mm A`);
    }
    return _DSTAdjusted(inDate).format(`${formatDateString}, HH:mm`);
};

export const formatTimeHMMSSA = intime => {
    if (formatTimeString12Hour) {
        return moment(intime).format('h:mm:ss A');
    }
    return moment(intime).format('H:mm:ss');
};

export const formatDateDST = inDate => {
    return _DSTAdjusted(inDate).format(formatDateString);
};

//Na Ned, poveche mu haresaha tezi
// public static timeStampTotalSeconds(timestamp: string): number {
//     const time = timestamp.split(':');
//     const timestampFractions = time.length;
//     switch (timestampFractions) {
//         case 1:
//             return parseInt(time[0], 10);
//         case 2:
//             return parseInt(time[0], 10) * 60 + parseInt(time[1], 10);
//         case 3:
//             return parseInt(time[0], 10) * 3600 + parseInt(time[1], 10) * 60 + parseInt(time[2], 10);
//         default:
//             return -1;
//     }
// }

// public static timeStampTotalSecondsStr(timestamp: string): string {
//     const seconds = TimingFormat.timeStampTotalSeconds(timestamp);
//     if (seconds < 0) {
//         return '';
//     }
//     return seconds.toString();
// }

export const getSecondsFromTimeSpan = (timeSpan: string): number => {
    let seconds = 0;

    if (timeSpan) {
        const splitTime = timeSpan.split(':');

        if (splitTime.length === 1) {
            seconds += +splitTime[0];
        } else if (splitTime.length === 2) {
            seconds += +splitTime[0] * 60;
            seconds += +splitTime[1];
        } else if (splitTime.length === 3) {
            seconds += +splitTime[0] * 3600;
            seconds += +splitTime[1] * 60;
            seconds += +splitTime[2];
        }
    }

    return seconds;
};

export const getSecondsStrFromTimeSpan = (timestamp: string): string => {
    const seconds = getSecondsFromTimeSpan(timestamp);
    if (seconds < 0) {
        return '';
    }
    return seconds.toString();
};

export const getTimeSpanFromSeconds = (seconds: number): string => {
    let timeSpan = '00:00';
    if (seconds >= 3600) {
        const hr = Math.floor(seconds / 3600);
        const totalMin = seconds % 3600;

        const min = Math.floor(totalMin / 60);
        let minString = '';
        if (min <= 9) minString = '0' + min;
        else minString = '' + min;

        const sec = totalMin % 60;
        let secString = '';
        if (sec <= 9) secString = '0' + sec;
        else secString = '' + sec;

        timeSpan = `${hr}:${minString}:${secString}`;
    } else if (seconds >= 60) {
        const min = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60);
        if (sec <= 9) {
            timeSpan = `${min}:0${sec}`;
        } else {
            timeSpan = `${min}:${sec}`;
        }
    } else if (seconds > 0) {
        if (seconds <= 9) {
            timeSpan = `00:0${Math.floor(seconds)}`;
        } else {
            timeSpan = `00:${Math.floor(seconds)}`;
        }
    }

    return timeSpan;
};

export const getTimeSpanWithHoursFromSeconds = (seconds: number): string => {
    let timeSpan = '00:00:00';
    if (seconds >= 3600) {
        const hr = Math.floor(seconds / 3600);
        const totalMin = seconds % 3600;

        const min = Math.floor(totalMin / 60);
        let minString = '';
        if (min <= 9) minString = '0' + min;
        else minString = '' + min;

        const sec = totalMin % 60;
        let secString = '';
        if (sec <= 9) secString = '0' + sec;
        else secString = '' + sec;

        timeSpan = `${hr}:${minString}:${secString}`;
    } else if (seconds >= 60) {
        const min = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60);
        if (sec <= 9) {
            timeSpan = `00:${min}:0${sec}`;
        } else {
            timeSpan = `00:${min}:${sec}`;
        }
    } else if (seconds > 0) {
        if (seconds <= 9) {
            timeSpan = `00:00:0${Math.floor(seconds)}`;
        } else {
            timeSpan = `00:00:${Math.floor(seconds)}`;
        }
    }
    return timeSpan;
};

export const getTimingBarText = (timingObject: any): string => {
    if (timingObject == null || timingObject.OverUnder == null) return '';

    let overUnder: string = timingObject.OverUnder;

    if (overUnder === '00:00:00') {
        return 'Timed OK';
    } else if (overUnder[0] === '-') {
        overUnder = overUnder.substring(1);
        if (overUnder.startsWith('00:')) {
            overUnder = overUnder.substring(3);
        }
        return 'Under ' + overUnder;
    } else {
        if (overUnder.startsWith('00:')) {
            overUnder = overUnder.substring(3);
        }
        return 'Over ' + overUnder;
    }
};

export const convertToDurationFieldFormat = (duration: string): string => {
    const hasDurationHour = duration.length > 6 ? true : false;
    const regex = hasDurationHour ? /(\d+)'(\d+)'(\d+)"/ : /(\d+)'(\d+)"/;
    const matches = duration.toString().trim().match(regex);
    if (hasDurationHour && matches && matches.length === 4) {
        const hours = parseInt(matches[1], 10);
        const minutes = parseInt(matches[2], 10);
        const seconds = parseInt(matches[3], 10);
        if (minutes < 60 && seconds < 60) {
            return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
        }
    } else if (matches && matches.length === 3) {
        const minutes = parseInt(matches[1], 10);
        const seconds = parseInt(matches[2], 10);
        return '00' + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    } else {
        return 'Invalid format';
    }
};

export const convertDurationToENPSClientFormat = (duration: string): string => {
    const durationPositions = duration.split(':');
    if (durationPositions.length === 3) {
        const hours = parseInt(durationPositions[0], 10);
        const minutes = parseInt(durationPositions[1], 10);
        const seconds = String(parseInt(durationPositions[2], 10)).padStart(2, '0');
        if (hours === 0) {
            return `${minutes}'${seconds}"`;
        }

        return `${hours}'${String(minutes).padStart(2, '0')}'${seconds}"`;
    } else {
        return 'Invalid format';
    }
};

export const secondsToTime = sec => {
    return moment.utc(Number(sec) * 1000).format('HH:mm:ss');
};
